import React from "react";
import { IconProps, Tooltip } from "@mui/material";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import TrendingDownIcon from "@mui/icons-material/TrendingDown";
import TrendingFlatIcon from "@mui/icons-material/TrendingFlat";
import { Translations } from "ui/Scripts/source/models/translations";

interface IAppTrendingIconProps extends IconProps {
    prevValue: number;
    value: number;
}

export const AppTrendingIcon = (props: IAppTrendingIconProps) => {
    return (
        <Tooltip title={props.prevValue < props.value
            ? Translations.TrendingUp
            : (props.prevValue > props.value
                ? Translations.TrendingDown
                : Translations.TrendingFlat
            )}>
            {(props.prevValue < props.value
                ? <TrendingUpIcon color="error" />
                : (props.prevValue > props.value
                    ? <TrendingDownIcon color="success" />
                    : <TrendingFlatIcon />
                )
            )}
        </Tooltip>
    );
};